import { _get, _post } from "../../../http";

//Endpoints para la gestión de paquetes escolares

export const getAlumnosPaqueteEscolar = (tutorId) =>
  _get(`/market-place/paqueteEscolar/tutor/${tutorId}/obtenerAlumnos`);

export const postGuardarArticulosAdquiridos = (tutorId, body) =>
  _post(`/market-place/paqueteEscolar/tutor/${tutorId}/guardarArticulosAdquiridos`, body);
